export default __webpack_public_path__ + "static/media/no_assignee.a1f5c940.svg";